export const patch = "15.11.1";

/* eslint-disable max-len */
export const ITEMICONURL = `http://ddragon.leagueoflegends.com/cdn/${patch}/img/item/`;
export const PROFILEPICONURL =
  "https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/v1/profile-icons/";
export const CHAMPIONICONURL =
  "https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/v1/champion-icons/";
export const RUNEICONURL =
  "https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/v1/";
export const CHAMPIONSPLASHURL =
  "https://raw.communitydragon.org/14.9/plugins/rcp-be-lol-game-data/global/default/v1/champion-splashes/";

export const getChampionSplash = (champId) =>
  `${CHAMPIONSPLASHURL}${champId}/${champId}000.jpg`;

export const championIds = {
  1: "Annie",
  2: "Olaf",
  3: "Galio",
  4: "TwistedFate",
  5: "XinZhao",
  6: "Urgot",
  7: "Leblanc",
  8: "Vladimir",
  9: "Fiddlesticks",
  10: "Kayle",
  11: "MasterYi",
  12: "Alistar",
  13: "Ryze",
  14: "Sion",
  15: "Sivir",
  16: "Soraka",
  17: "Teemo",
  18: "Tristana",
  19: "Warwick",
  20: "Nunu",
  21: "MissFortune",
  22: "Ashe",
  23: "Tryndamere",
  24: "Jax",
  25: "Morgana",
  26: "Zilean",
  27: "Singed",
  28: "Evelynn",
  29: "Twitch",
  30: "Karthus",
  31: "Chogath",
  32: "Amumu",
  33: "Rammus",
  34: "Anivia",
  35: "Shaco",
  36: "DrMundo",
  37: "Sona",
  38: "Kassadin",
  39: "Irelia",
  40: "Janna",
  41: "Gangplank",
  42: "Corki",
  43: "Karma",
  44: "Taric",
  45: "Veigar",
  48: "Trundle",
  50: "Swain",
  51: "Caitlyn",
  53: "Blitzcrank",
  54: "Malphite",
  55: "Katarina",
  56: "Nocturne",
  57: "Maokai",
  58: "Renekton",
  59: "JarvanIV",
  60: "Elise",
  61: "Orianna",
  62: "MonkeyKing",
  63: "Brand",
  64: "LeeSin",
  67: "Vayne",
  68: "Rumble",
  69: "Cassiopeia",
  72: "Skarner",
  74: "Heimerdinger",
  75: "Nasus",
  76: "Nidalee",
  77: "Udyr",
  78: "Poppy",
  79: "Gragas",
  80: "Pantheon",
  81: "Ezreal",
  82: "Mordekaiser",
  83: "Yorick",
  84: "Akali",
  85: "Kennen",
  86: "Garen",
  89: "Leona",
  90: "Malzahar",
  91: "Talon",
  92: "Riven",
  96: "KogMaw",
  98: "Shen",
  99: "Lux",
  101: "Xerath",
  102: "Shyvana",
  103: "Ahri",
  104: "Graves",
  105: "Fizz",
  106: "Volibear",
  107: "Rengar",
  110: "Varus",
  111: "Nautilus",
  112: "Viktor",
  113: "Sejuani",
  114: "Fiora",
  115: "Ziggs",
  117: "Lulu",
  119: "Draven",
  120: "Hecarim",
  121: "Khazix",
  122: "Darius",
  126: "Jayce",
  127: "Lissandra",
  131: "Diana",
  133: "Quinn",
  134: "Syndra",
  136: "AurelionSol",
  141: "Kayn",
  142: "Zoe",
  143: "Zyra",
  145: "Kaisa",
  147: "Seraphine",
  150: "Gnar",
  154: "Zac",
  157: "Yasuo",
  161: "Velkoz",
  163: "Taliyah",
  164: "Camille",
  166: "Akshan",
  200: "Belveth",
  201: "Braum",
  202: "Jhin",
  203: "Kindred",
  221: "Zeri",
  222: "Jinx",
  223: "TahmKench",
  233: "Briar",
  234: "Viego",
  235: "Senna",
  236: "Lucian",
  238: "Zed",
  240: "Kled",
  245: "Ekko",
  246: "Qiyana",
  254: "Vi",
  266: "Aatrox",
  267: "Nami",
  268: "Azir",
  350: "Yuumi",
  360: "Samira",
  412: "Thresh",
  420: "Illaoi",
  421: "RekSai",
  427: "Ivern",
  429: "Kalista",
  432: "Bard",
  497: "Rakan",
  498: "Xayah",
  516: "Ornn",
  517: "Sylas",
  518: "Neeko",
  523: "Aphelios",
  526: "Rell",
  555: "Pyke",
  711: "Vex",
  777: "Yone",
  799: "Ambessa",
  800: "Mel",
  804: "Yunara",
  875: "Sett",
  876: "Lillia",
  887: "Gwen",
  888: "Renata",
  893: "Aurora",
  895: "Nilah",
  897: "KSante",
  901: "Smolder",
  902: "Milio",
  910: "Hwei",
  950: "Naafiri",
};

export const romanNumbers = {
  I: 1,
  II: 2,
  III: 3,
  IV: 4,
  V: 5,
};

export const queueIds = {
  0: "",
  2: "Blind Pick",
  4: "Ranked Solo",
  6: "Ranked Premade",
  7: "Co-op vs AI",
  8: "3v3 Normal",
  9: "3v3 Ranked Flex",
  14: "Draft Pick",
  16: "Dominion Blind Pick",
  17: "Dominion Draft Pick",
  25: "Dominion Co-op vs AI",
  31: "Co-op vs AI Intro Bot",
  32: "Co-op vs AI Beginner Bot",
  33: "Co-op vs AI Intermediate Bot",
  41: "3v3 Ranked Team",
  42: "Ranked Team",
  52: "Co-op vs AI",
  61: "Team Builder",
  65: "ARAM",
  67: "ARAM Co-op vs AI",
  70: "One for All",
  72: "1v1 Snowdown Showdown",
  73: "2v2 Snowdown Showdown",
  75: "6v6 Hexakill",
  76: "Ultra Rapid Fire",
  78: "One For All: Mirror Mode",
  83: "Co-op vs AI Ultra Rapid Fire",
  91: "Doom Bots Rank 1",
  92: "Doom Bots Rank 2",
  93: "Doom Bots Rank 5",
  96: "Ascension",
  98: "6v6 Hexakill",
  100: "ARAM",
  300: "Legend of the Poro King",
  310: "Nemesis",
  313: "Black Market Brawlers",
  315: "Nexus Siege",
  317: "Definitely Not Dominion",
  318: "ARURF",
  325: "All Random",
  400: "Draft Pick",
  410: "Ranked Dynamic",
  420: "Ranked Solo",
  430: "Blind Pick",
  440: "Ranked Flex",
  450: "ARAM",
  460: "3v3 Blind Pick",
  470: "3v3 Ranked Flex",
  600: "Blood Hunt Assassin",
  610: "Dark Star: Singularity",
  700: "Clash",
  800: "Co-op vs. AI Intermediate Bot",
  810: "Co-op vs. AI Intro Bot",
  820: "Co-op vs. AI Beginner Bot",
  830: "Co-op vs. AI Intro Bot",
  840: "Co-op vs. AI Beginner Bot",
  850: "Co-op vs. AI Intermediate Bot",
  900: "ARURF",
  910: "Ascension",
  920: "Legend of the Poro King",
  940: "Nexus Siege",
  950: "Doom Bots Voting",
  960: "Doom Bots Standard",
  980: "Star Guardian Invasion: Normal",
  990: "Star Guardian Invasion: Onslaught",
  1000: "PROJECT: Hunters",
  1010: "Snow ARURF",
  1020: "One for All",
  1030: "Odyssey Extraction: Intro",
  1040: "Odyssey Extraction: Cadet",
  1050: "Odyssey Extraction: Crewmember",
  1060: "Odyssey Extraction: Captain",
  1070: "Odyssey Extraction: Onslaught",
  1090: "Teamfight Tactics",
  1100: "Ranked Teamfight Tactics",
  1110: "Teamfight Tactics Tutorial",
  1111: "Teamfight Tactics test",
  1200: "Nexus Blitz",
  1300: "Nexus Blitz",
  1400: "Ultimate Spellbook",
  1900: "Pick URF",
  2000: "Tutorial 1",
  2010: "Tutorial 2",
  2020: "Tutorial 3",
};

export const summonerSpells = {
  1: "Cleanse",
  3: "Exhaust",
  4: "Flash",
  6: "Ghost",
  7: "Heal",
  11: "Smite",
  12: "Teleport",
  13: "Clarity",
  14: "Ignite",
  21: "Barrier",
  30: "PoroKing Recall",
  31: "Poro Toss",
  32: "Mark",
  39: "Mark",
};

export const summonerSpellsUrl = {
  1: "https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/data/spells/icons2d/summoner_boost.png",
  3: "https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/data/spells/icons2d/summoner_exhaust.png",
  4: "https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/data/spells/icons2d/summoner_flash.png",
  6: "https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/data/spells/icons2d/summoner_haste.png",
  7: "https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/data/spells/icons2d/summoner_heal.png",
  11: "https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/data/spells/icons2d/summoner_smite.png",
  12: "https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/data/spells/icons2d/summoner_teleport_new.png",
  14: "https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/data/spells/icons2d/summonerignite.png",
  21: "https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/data/spells/icons2d/summonerbarrier.png",
};

export const baronWinUrl = "https://s-lol-web.op.gg/images/icon/icon-baron.svg";

export const dragonWinUrl =
  "https://s-lol-web.op.gg/images/icon/icon-dragon.svg";

export const turretWinUrl =
  "https://s-lol-web.op.gg/images/icon/icon-tower.svg";

export const baronLoseUrl =
  "https://s-lol-web.op.gg/images/icon/icon-baron-r.svg";

export const dragonLoseUrl =
  "https://s-lol-web.op.gg/images/icon/icon-dragon-r.svg";

export const turretLoseUrl =
  "https://s-lol-web.op.gg/images/icon/icon-tower-r.svg";
